class IngredientsCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-carousel-track]');
    this.prevBtn = root.querySelector('[data-carousel-prev]');
    this.nextBtn = root.querySelector('[data-carousel-next]');
    this.dots = Array.from(root.querySelectorAll('[data-carousel-dot]'));

    if (!this.track) return;

    this.cards = Array.from(this.track.children);
    if (this.cards.length === 0) return;

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.scrollByCard(-1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.scrollByCard(1));
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.scrollToIndex(Number(dot.dataset.index)));
    });

    this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
    window.addEventListener('resize', () => this.onScroll());

    this.onScroll();
  }

  cardStep() {
    const card = this.cards[0];
    const style = window.getComputedStyle(this.track);
    const gap = parseFloat(style.columnGap || style.gap || '0');
    return card.getBoundingClientRect().width + gap;
  }

  scrollByCard(direction) {
    this.track.scrollBy({ left: this.cardStep() * direction, behavior: 'smooth' });
  }

  scrollToIndex(index) {
    this.track.scrollTo({ left: this.cardStep() * index, behavior: 'smooth' });
  }

  onScroll() {
    const scrollLeft = this.track.scrollLeft;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;

    if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 4;
    if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll - 4;

    if (this.dots.length) {
      const step = this.cardStep();
      const activeIndex = Math.round(scrollLeft / step);
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
    }
  }
}

function initIngredientsCarousels() {
  document.querySelectorAll('.ingredients-carousel').forEach((root) => {
    if (root.dataset.carouselInit) return;
    root.dataset.carouselInit = 'true';
    new IngredientsCarousel(root);
  });
}

function initIngredientsModals() {
  document.querySelectorAll('.ingredients-carousel').forEach((section) => {
    const modal = section.querySelector('[data-modal]');
    if (!modal || modal.dataset.modalInit) return;
    modal.dataset.modalInit = 'true';

    const img = modal.querySelector('[data-modal-image]');
    let lastFocused = null;

    const openModal = (src, alt) => {
      lastFocused = document.activeElement;
      img.src = src;
      img.alt = alt || '';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modal.querySelector('[data-modal-close]').focus();
    };

    const closeModal = () => {
      modal.hidden = true;
      img.src = '';
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    };

    section.querySelectorAll('[data-modal-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        openModal(trigger.dataset.modalSrc, trigger.dataset.modalAlt);
      });
    });

    modal.querySelectorAll('[data-modal-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initIngredientsCarousels();
    initIngredientsModals();
  });
} else {
  initIngredientsCarousels();
  initIngredientsModals();
}

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('.ingredients-carousel');
  if (root) {
    delete root.dataset.carouselInit;
    new IngredientsCarousel(root);
    initIngredientsModals();
  }
});